module.exports = __webpack_public_path__ + "img/product-9.ad48834.jpg";